export default [
  {
    category: "WebDesign",
    imgSrc: "images/portfolio/01.jpg",
    title: "Social Marketing",
    description: "Networking solutions for worldwide c",
    details: "Cum sociis natoque penatibus et magnis dis .",
  },
  {
    category: "AppDesign",
    imgSrc: "images/portfolio/02.jpg",
    title: "Web Development",
    description:
      "Networking solutions for worldwide communication. We're a company that focuses on establishing long-term relationships with customers.",
    details:
      "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisquenisl consectetur et. Vivamus sagittis lacus vel augue rutrum.",
  },
  {
    category: "Branding",
    imgSrc: "images/portfolio/03.jpg",
    title: "Design Work",
    description:
      "Networking solutions for worldwide communication. We're a company that focuses on establishing long-term relationships with customers.",
    details:
      "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisquenisl consectetur et. Vivamus sagittis lacus vel augue rutrum.",
  },
  {
    category: "AppDesign",
    imgSrc: "images/portfolio/04.jpg",
    title: "App Management",
    description:
      "Networking solutions for worldwide communication. We're a company that focuses on establishing long-term relationships with customers.",
    details:
      "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisquenisl consectetur et. Vivamus sagittis lacus vel augue rutrum.",
  },
  {
    category: "Branding",
    imgSrc: "images/portfolio/05.jpg",
    title: "Hosting Service",
    description:
      "Networking solutions for worldwide communication. We're a company that focuses on establishing long-term relationships with customers.",
    details:
      "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisquenisl consectetur et. Vivamus sagittis lacus vel augue rutrum.",
  },
  {
    category: "Branding",
    imgSrc: "images/portfolio/03.jpg",
    title: "Design Clone",
    description:
      "Networking solutions for worldwide communication. We're a company that focuses on establishing long-term relationships with customers.",
    details:
      "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisquenisl consectetur et. Vivamus sagittis lacus vel augue rutrum.",
  },
];
